export default __webpack_public_path__ + "static/media/driver-slide4.71784ce9.jpg";